export const createTagData = {
  TAG: {
    heading: "Tag",
    labelName: "Tag Name",
    nameError: "Enter Tag Name",
    labelDescription: "Tag Description",
    descriptionError: "Enter Tag Description",
    createBtn: "Create Tag",
  },
  CATEGORY: {
    heading: "Category",
    labelName: "Category Name",
    nameError: "Enter Category Name",
    labelDescription: "Category Description",
    descriptionError: "Enter Category Description",
    createBtn: "Create Category",
  },
  SUBCATEGORY: {
    heading: "Sub-Category",
    labelName: "Sub-Category Name",
    nameError: "Enter Sub-Category Name",
    labelDescription: "Sub-Category Description",
    descriptionError: "Enter Sub-Category Description",
    createBtn: "Create Sub-Category",
  },
};
